import { getStroke } from './getStroke'

export default getStroke

export * from './getStrokeOutlinePoints'
export * from './getStrokePoints'
export * from './getStroke'
export * from './types'
